import { Injectable } from '@angular/core';
import { Shipment } from 'app-modules/core/models/shipment.model';

@Injectable()
export abstract class IEditShipmentPopup {
    abstract OpenEditShipmentPopup(shipment?: Shipment): void;
}
